import HttpClient from "@/common/boot/HttpClient"

const downloadBlobResponse = (response, defaultFileName = 'exportacao') => {
  const contentType =
    response.headers['content-type'] || 'application/octet-stream';

  const blob = new Blob([response.data], { type: contentType });

  const disposition = response.headers['content-disposition'];
  let fileName = defaultFileName;

  if (disposition) {
    const match = disposition.match(/filename="?(.+?)"?$/);
    if (match && match[1]) {
      fileName = match[1];
    }
  }

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const listarProvedoresMulta = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(
      `ctrl-provedores/visualizar-multa-provedores`,
      payload
    );

    commit('LISTAR_DADOS_PROVEDORES', response.data.data);
    return response;

  } catch (error) {
    commit('LISTAR_DADOS_PROVEDORES', { data: [], total: 0 });
  } finally {
    commit('CARREGANDO', false);
  }
};


const listarProvedorMulta = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(
      `ctrl-provedores/visualizar-multa-provedor/${payload.id}`,
      payload
    );

    const provedor = response.data.provedor;
    const workflows = response.data.workflows.original.data;

    commit('LISTAR_DADOS_PROVEDOR', provedor);
    commit('LISTAR_WORKFLOWS_PROVEDOR', workflows);

    return response;

  } catch (error) {
    commit('LISTAR_DADOS_PROVEDOR', null);
    commit('LISTAR_WORKFLOWS_PROVEDOR', { data: [] });
  } finally {
    commit('CARREGANDO', false);
  }
};

const setFiltroData = ({ commit }, payload) => {
  commit('SET_FILTRO_DATA', payload);
};

const exportarMultaProvedores = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(
      `ctrl-provedores/exportar-multa-provedores`,
      payload,
      { responseType: 'blob' }
    );

    downloadBlobResponse(response, 'multa-provedores-exportacao');
  } catch (error) {
    console.error('Erro ao exportar multas dos provedores:', error);
  } finally {
    commit('CARREGANDO', false);
  }
};

const exportarMultaProvedor = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  try {
    const { ctrl_provedor_id, ...body } = payload;

    const response = await HttpClient.post(
      `ctrl-provedores/exportar-multa-provedor/${ctrl_provedor_id}`,
      body,
      { responseType: 'blob' }
    );

    downloadBlobResponse(response, 'multa-provedor-exportacao');
  } catch (error) {
    console.error('Erro ao exportar multas do provedor:', error);
  } finally {
    commit('CARREGANDO', false);
  }
};

export {
  listarProvedoresMulta,
  listarProvedorMulta,
  setFiltroData,
  exportarMultaProvedores,
  exportarMultaProvedor
}
